import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Modal} from "antd";
import {logout} from "./actions";

const confirm = Modal.confirm;

class LogoutPage extends Component {
  componentDidMount() {
    const {history} = this.props;
    confirm({
      title: 'Logout',
      content: 'Are you sure you want to logout?',
      onOk: () => {
        this.logout();
        setTimeout(() => history.push("/"), 0);
      },
      onCancel() {
        setTimeout(() => history.goBack(), 0);
      }
    });
  }

  logout() {
    const {token} = this.props;
    this.props.logout(token);
  }

  render() {
    return <div></div>;
  }
}
LogoutPage.propTypes = {
  token: PropTypes.object,
  history: PropTypes.object,
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  token: state.auth.token,
});
const mapDispatchToProps = dispatch => ({
  logout: bindActionCreators(logout, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);



// WEBPACK FOOTER //
// ./src/Auth/LogoutPage.js